export default __webpack_public_path__ + "static/media/6_1.0bd8bc04.jpg";